import { render, staticRenderFns } from "./EMRVersion.vue?vue&type=template&id=296ea826&scoped=true"
import script from "./EMRVersion.vue?vue&type=script&lang=js"
export * from "./EMRVersion.vue?vue&type=script&lang=js"
import style0 from "./EMRVersion.vue?vue&type=style&index=0&id=296ea826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296ea826",
  null
  
)

export default component.exports